
    import { Vue, Component } from 'vue-property-decorator'
    @Component({
        name: 'read'
    })
    export default class read extends Vue {
        visible = false
        loading = false
        dialogVisible = false
        dataForm = {
            id:'',
            content:'',
            customerId:'',
            time:'',
            customerName:'',
            contact:'',
            phoneNumber:'',
            imgList:'',
            userName:'',
            replyContent: ''
        }
        replyContentFrom = {
            id:'',
            content:'',
            replyContent: '',
            customerReadState: ''
        }
       
        init(id: string) {
                if(!id) return;
                this.visible = true
                this.$nextTick(() => {
                    this.loading = true
                    this.$request({
                        url: `/bjba/feedback/info/${id}`,
                        method: 'get'
                    }).then(({data}) => {
                        this.loading = false
                        if (data.data) {
                            this.dataForm.id = data.data.id
                            this.dataForm.content = data.data.content
                            this.dataForm.customerId = data.data.customerId
                            this.dataForm.time = data.data.time
                            this.dataForm.customerName = data.data.customerName
                            this.dataForm.contact = data.data.contact
                            this.dataForm.phoneNumber = data.data.phoneNumber
                            this.dataForm.imgList = data.data.imgList
                            this.dataForm.userName = data.data.userName
                            this.dataForm.replyContent = data.data.replyContent
                        }
                    }).catch(err => {
                        this.loading = false
                        this.$message({
                            message: '获取信息出现异常!',
                            type: 'error',
                            center: true,
                            showClose: true
                        })
                    })
                })

            }
            handleClose() {
                this.visible = false
                this.$emit('refreshDataList')
            }
            reply(data: any) {
                console.log("回复数据为：",data)
                this.dialogVisible = true
                this.replyContentFrom.id = data.id
                this.replyContentFrom.content = data.content
                this.replyContentFrom.replyContent = data.replyContent
                this.replyContentFrom.customerReadState = '01'
                console.log("问题回复表单数据为：",this.replyContentFrom)
            }
            submitReplyMessage() {
                this.$request({
                    url: `/bjba/feedback/updateReplyContent`,
                    method: 'post',
                    data: this.replyContentFrom
                }).then(({data}) => {
                    this.dialogVisible = false
                    if (data && data.code === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                        this.init(this.dataForm.id)
                    } else if(data && data.code === 500) {
                        this.$message({
                            message: data.message,
                            type: 'error',
                            duration: 1500
                        })
                    }
                }).catch(error => {
                    this.dialogVisible = false;
                    console.log(error)
                    this.$message({
                        message: '操作失败',
                        type: 'error',
                        duration: 1500
                    })
                });
            }
    }
